<template>
  <div class="reward">
    <div class="header" v-if="rewardList.length">
      <div class="headerMain">
        <div class="start">问卷</div>
        <div class="end">
          <div>奖励</div>
          <div>类型</div>
        </div>
      </div>
    </div>
    <div v-if="showEmpty">
      <van-empty description="暂无奖励记录~" />
    </div>
    <div class="list" v-else>
      <div class="money" v-if="rewardList.length > 0">
        <div class="title">已获得奖励</div>
        <div class="content">
          <span class="num">{{totalMoney || '--'}}</span>
          <span class="unit">元</span>
        </div>
      </div>
      <div v-for="item in rewardList" :key="item.id" class="reward-item">
        <div class="left">
          <div class="icon">
            <div class="typeName">{{item.type | filterType}}</div>
          </div>
          <div class="info">
            <div class="name">{{item.qname}}</div>
            <div class="time">{{item.createtime | fmtTime}}</div>
          </div>
        </div>
        <div class="right">
          <div class="num">{{item.money}}</div>
          <div class="type">{{item.type | filterType}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRewardList } from "../../api/user"
import store from '../../store/index'
import { formatTime } from '../../util/index'
export default {
  created() {
    const userInfo = store.getters.userInfo
    if (userInfo) {
      this.id = userInfo.user.id
      this.getList()
    }
  },
  data() {
    return {
      rewardList: [],
      id: "",
      showEmpty: false,
    };
  },
  methods: {
    getList() {
      getRewardList({
        uid: this.id,
        status: "RECEIVED",
      }).then((res) => {
        if(res.data.length === 0) {
          this.showEmpty = true
          return
        }
        this.rewardList = res.data;
      });
    },
  },
  filters: {
    filterType(val) {
      if (val === 0 || val === 3) {
        return '答题'
      } else {
        return '推广'
      }
    },
    fmtTime(val) {
      if (val) {
        const res = formatTime(val)
        return `${res.year}/${res.month}/${res.day}   ${res.hour}:${res.minute}:${res.second}`
      }
      return '2019/02/01  19:34:30'
    }
  },
  computed: {
    totalMoney: {
      get() {
        const res = this.rewardList.reduce((total, item)=>{
          return Number(total) + Number(item.money)
        }, 0)
        return res
      }
    }
  }
};
</script>

<style lang="stylus">
.reward {
  min-height: 100vh;
  background: #F2F2F2;
  .header {
    position: fixed;
    z-index: 10;
    background: #FFFFFF;
    box-shadow: 0px 0px 24px 0px rgba(0, 56, 112, 0.1);
    height: 100px;
    width: 100%;
    top: 0;
    color: #333333;
    font-size: 28px;
    .headerMain {
      width: 100%;
      height: 100%
      display: flex;
      justify-content: space-between;
      align-items: center;
      .end {
        padding-right: 50px;
        width: 160px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .start {
        padding-left: 30px;
      }
    }
  }
  .list {
    padding: 130px 30px 30px 30px;
    .money {
      padding: 50px 30px;
      background-image: url('../../assets/images/money_bg.png')
      color: #FFFFFF;
      background-size: cover;
      border-radius: 10px;
      .title {
        font-size: 26px;
        opacity: 0.9;
      }
      .content {
        margin-top: 30px;
        display: flex;
        align-items: center;
        .num {
          opacity: 0.9;
          font-size: 54px;
        }
        .unit {
          opacity: 0.9;
          font-size: 26px;
          margin-left: 20px;
          padding-top:10px;
        }
      }
    }
    .reward-item {
      margin-top: 30px;
      padding: 48px 30px;
      display: flex;
      background: #FFFFFF;
      border-radius: 10px;
      font-size: 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        overflow: hidden;
        .icon {
          background-image: url('../../assets/images/icon/type.png');
          background-size: cover;
          width: 60px;
          height: 60px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          .typeName{
            width: 30px;
            text-align: center;
            color: #fff;
            line-height: 22px;
          }
        }
        .info {
          margin-left: 11px;
          max-width: 360px;
          overflow: hidden;
          white-space: nowrap;
          .name {
            font-weight: bold;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .time {
            margin-top: 11px;
            color: #888888;
            font-size: 20px;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        width: 140px;
      }
    }
  }
}
</style>
